module.exports = __webpack_public_path__ + "img/icon_management.55099ba0.png";